var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7.625V8.375C16 8.58333 15.9271 8.76042 15.7812 8.90625C15.6354 9.05208 15.4583 9.125 15.25 9.125H9.125V15.25C9.125 15.4583 9.05208 15.6354 8.90625 15.7812C8.76042 15.9271 8.58333 16 8.375 16H7.625C7.41667 16 7.23958 15.9271 7.09375 15.7812C6.94792 15.6354 6.875 15.4583 6.875 15.25V9.125H0.75C0.541667 9.125 0.364583 9.05208 0.21875 8.90625C0.072917 8.76042 0 8.58333 0 8.375V7.625C0 7.41667 0.072917 7.23958 0.21875 7.09375C0.364583 6.94792 0.541667 6.875 0.75 6.875H6.875V0.75C6.875 0.541667 6.94792 0.364583 7.09375 0.21875C7.23958 0.072917 7.41667 0 7.625 0H8.375C8.58333 0 8.76042 0.072917 8.90625 0.21875C9.05208 0.364583 9.125 0.541667 9.125 0.75V6.875H15.25C15.4583 6.875 15.6354 6.94792 15.7812 7.09375C15.9271 7.23958 16 7.41667 16 7.625Z",
    fill: "#00729a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.7debcf2688f82934aa6db76600b18ddf.svg";
export { ForwardRef as ReactComponent };